export default {
  //DataTable
  "DataTable.body.noMatch": "対象データが存在しません",
  "DataTable.body.toolTip": "ソート",
  "DataTable.body.columnHeaderTooltip": "{column}　でソート",
  "DataTable.pagination.next": "次へ",
  "DataTable.pagination.previous": "前へ",
  "DataTable.pagination.rowsPerPage": "1ページ内の表示件数:",
  "DataTable.pagination.displayRows": "{count} 件中 {from} - {to} 件目を表示",
  "DataTable.toolbar.search": "検索",
  "DataTable.toolbar.downloadCsv": "CSVダウンロード",
  "DataTable.toolbar.print": "印刷",
  "DataTable.toolbar.viewColumns": "項目表示切替",
  "DataTable.toolbar.filterTable": "フィルタ",
  "DataTable.filter.all": "全て",
  "DataTable.filter.title": "フィルタ設定",
  "DataTable.filter.reset": "フィルタ解除",
  "DataTable.viewColumns.title": "Show Columns",
  "DataTable.viewColumns.titleAria": "Show/Hide Table Columns",
  "DataTable.selectedRows.text": "row(s) selected",
  "DataTable.selectedRows.delete": "Delete",
  "DataTable.selectedRows.deleteAria": "Delete Selected Rows",
  
  //Dialog
  "Dialog.btn.ok" : "はい",
  "Dialog.btn.cancel": "いいえ",
  "Dialog.btn.close": "閉じる",
  "Dialog.context.register": "この内容で登録してよろしいですか？",
  "Dialog.context.update": "この内容で更新してよろしいですか？",
  "Dialog.context.delete": "削除してよろしいですか？",
  "Dialog.context.upload": "ファイルをアップロードしてもよろしいですか？",

  //FileSelect
  "FileSelect.err.typepermission": "許可されていないファイルの種類です",
  "FileSelect.err.sizeover": "ファイルサイズが上限を超えています",
  "FileSelect.err.title": "エラー",
  "FileSelect.noSelect": "ファイルが選択されていません",
  
  //Header
  "Header.MenuBar.logout": "ログアウト",
  
  //TimeCheck
  "TimeCheck.err.timeout": "セッションタイムアウト { value }",
  "TimeCheck.btn.close": "閉じる",
  
  //validate
  "validate.required": "必須項目です",
  "validate.maxLength": "{length}文字以下で入力してください",
  "validate.minLength": "{length}文字以上で入力してください",
  "validate.type.email": "メールアドレスの形式で入力してください",
  "validate.type.url": "URLの形式で入力してください",
  "validate.type.password": "半角英小文字・半角英大文字・半角数字を組み合わせた形式で入力してください",
  "validate.type.number": "半角数字のみで入力してください",
  "validate.type.alphabet": "半角英字のみで入力してください",
  "validate.type.alphabetNumber": "半角英数字のみで入力してください",
  "validate.type.fullWidth": "全角のみで入力してください",
  "validate.type.requiredPersonalName": "氏名を入力してください",
  "validate.type.correctDate": "生年月日が正しくありません",
};
